import { useEffect, useState } from 'react'

import storageHealthMonitorService, { StorageHealthMonitorService } from '../services/storage-health-monitor.service'
import type { IStorageWarning } from '../services/storage-health.service'


type StorageHealthMonitor = Pick<StorageHealthMonitorService, 'subscribe' | 'start' | 'stop'>

export const useStorageHealthWarnings = (
    isAuthorized: boolean,
    monitor: StorageHealthMonitor = storageHealthMonitorService,
) => {
    const [warnings, setWarnings] = useState<IStorageWarning[]>([])

    useEffect(() => {
        if (!isAuthorized) {
            setWarnings([])
            return
        }

        const unsubscribe = monitor.subscribe(setWarnings)
        void monitor.start()

        return () => {
            unsubscribe()
            monitor.stop()
        }
    }, [isAuthorized, monitor])

    return warnings
}